import { __assign } from "tslib";
import React, { useCallback, useState, useEffect } from 'react';
import { Box, COLOR_VARIANTS, color, 
// Tabs,
Icons } from '@tajawal/ct-web-design-system';
import { $cookie } from '@tajawal/web-core-sdk-v2/lib/services/cookie.service';
import { STORAGE_KEYS } from '@tajawal/web-core-sdk-v2/lib/constants';
import { ButtonBase } from '@mui/material';
import { useTranslation } from 'react-i18next';
// assets
import AlmosaferLogo from './components/AlmosaferLogo';
import WhatsappIcon from './assets/WhatsappIcon';
import UserIcon from './assets/UserIcon';
// components
import CurrencyDropdown from './components/CurrencyDropdown';
import WalletAmount from './components/WalletAmount';
// hooks
import { usePartnerReferer } from './hooks/usePartnerReferer';
import { pushGA4Event } from './utils/analytics.utils';
var PARTNER_REFERER = 'partner_referer';
var styles = {
    mainHeaderContainer: {
        width: '100%',
        zIndex: 200,
        // background: 'rgb(0, 49, 67)',
        // position: 'sticky',
        top: '0px',
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        fontSize: '14px'
        // background: color(COLOR_VARIANTS.HEADER),
        // color: color(COLOR_VARIANTS.HEADERTEXT)
    },
    headerContainer: {
        width: '100%',
        zIndex: 200,
        // background: color(COLOR_VARIANTS.HEADER),
        // position: 'sticky',
        top: '0px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px'
    },
    headerContents: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        maxWidth: '1200px',
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    actionBarContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    changeLanguageButton: {
        paddingLeft: '8px',
        paddingRight: '8px',
        cursor: 'pointer'
    },
    retrieveBookingButton: {
        paddingLeft: '8px',
        paddingRight: '8px',
        cursor: 'pointer'
    },
    whatsappNumber: {
        paddingLeft: '8px',
        paddingRight: '8px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    signInButtonContainer: {
        paddingLeft: '8px',
        paddingRight: '8px'
    },
    signInButton: {
        border: '1px solid rgb(255, 255, 255)',
        borderRadius: '100px',
        width: '120px',
        fontSize: '14px',
        padding: '4px 12px',
        lineHeight: 1.5
    },
    myAccountButton: {
        fontSize: '14px',
        padding: '4px 12px',
        lineHeight: 1.5
    },
    tabsContainer: {
        width: '100%',
        maxWidth: '1200px',
        mt: '15px'
    }
};
var HEADER_ITEMS = {
    // id: 1,
    // nav: true,
    currency: true,
    language: true,
    retrieveBooking: true,
    phone: true,
    signIn: true,
    myAccount: true
    // notification: false
};
var tabRoute = function (url) {
    if (url.includes('flights')) {
        return 'flights-home';
    }
    if (url.includes('hotels-home')) {
        return 'hotels-home';
    }
    if (url.includes('activities-home')) {
        return 'activities-home';
    }
    return '';
};
var HeaderV2 = function (_a) {
    var _b;
    var configStore = _a.configStore, currencyStore = _a.currencyStore, isLoggedIn = _a.isLoggedIn, query = _a.query, _c = _a.onChangeLanguage, onChangeLanguage = _c === void 0 ? undefined : _c, _d = _a.onCurrencyChange, onCurrencyChange = _d === void 0 ? undefined : _d, _e = _a.onRetrieveBookingClick, onRetrieveBookingClick = _e === void 0 ? undefined : _e, _f = _a.onSignInClick, onSignInClick = _f === void 0 ? undefined : _f, _g = _a.onMyAccountClick, onMyAccountClick = _g === void 0 ? undefined : _g, _h = _a.reloadOnCurrencyChange, reloadOnCurrencyChange = _h === void 0 ? true : _h, 
    // onOpenDrawer,
    _j = _a.isFullHeader, 
    // onOpenDrawer,
    isFullHeader = _j === void 0 ? undefined : _j, _k = _a.currencyList, currencyList = _k === void 0 ? undefined : _k, _l = _a.onOpenDrawer, onOpenDrawer = _l === void 0 ? undefined : _l, isFixed = _a.isFixed;
    var t = useTranslation().t;
    var _m = useState(''), tab = _m[0], setTab = _m[1];
    var language = configStore.language, whatsappLink = configStore.whatsappLink, dir = configStore.dir;
    var partnerRefererQuery = query[PARTNER_REFERER];
    var sessionPartnerReferer = usePartnerReferer(query);
    var partnerReferer = partnerRefererQuery || sessionPartnerReferer;
    var partnerContent = ((_b = configStore === null || configStore === void 0 ? void 0 : configStore.partnerConfig) === null || _b === void 0 ? void 0 : _b[partnerReferer]) || {};
    var headerDisplayedItems = __assign(__assign({}, HEADER_ITEMS), partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.headerDisplay);
    var handleLanguageChange = useCallback(function () {
        var newLanguage = language === 'en' ? 'ar' : 'en';
        $cookie.set(STORAGE_KEYS.LANGUAGE, newLanguage);
        // if callback is defined, call it only
        if (onChangeLanguage) {
            onChangeLanguage(newLanguage);
        }
        else {
            // pushLanguageChangeGTMEvent({ language: lang });
            // @ts-ignore
            window.location = window.location.href.replace("/".concat(language), "/".concat(newLanguage));
        }
    }, [language, onChangeLanguage]);
    useEffect(function () {
        setTab(tabRoute(window.location.href || ''));
    }, []);
    var handleCurrencyChange = useCallback(function (currency) {
        // pushCurrencyChangeGTMEvent(currency);
        currencyStore.setCurrentCurrency(currency);
        if (onCurrencyChange)
            onCurrencyChange(currency);
        $cookie.set(STORAGE_KEYS.CURRENCY, currency);
        // Required for hotels
        if (reloadOnCurrencyChange) {
            setTimeout(function () {
                window.location.reload();
            }, 10);
        }
    }, [onCurrencyChange, reloadOnCurrencyChange]);
    var handleRetrieveBooking = useCallback(function () {
        if (onRetrieveBookingClick)
            onRetrieveBookingClick();
        window.location.href = "/".concat(language, "/myaccount/retrieve-booking");
    }, [language, onRetrieveBookingClick]);
    var handleSignIn = useCallback(function () {
        if (onSignInClick)
            onSignInClick();
        onOpenDrawer(true);
        pushGA4Event('myAccount_login_cta_clicked', { page: 'header' });
        // window.location.href = `/${language}/signin?redirectUrl=${window.location.href}`;
    }, [language, onSignInClick]);
    var handleMyAccount = useCallback(function () {
        if (onMyAccountClick)
            onMyAccountClick();
        onOpenDrawer(true);
        // window.location.href = `/${language}/myaccount/booking/all`;
    }, [language, onMyAccountClick]);
    var navLinks = function () {
        var _a, _b, _c, _d, _e, _f;
        var availableProducts = configStore.availableProducts, partnerConfig = configStore.partnerConfig;
        var isPartnerRefererVal = partnerReferer
            ? "?partner_referer=".concat(partnerReferer)
            : '';
        return [
            {
                label: 'header.flights',
                testId: 'flights-home',
                value: 'flights-home',
                isEnabled: partnerReferer
                    ? (_b = (_a = partnerConfig[partnerReferer]) === null || _a === void 0 ? void 0 : _a.availableProducts) === null || _b === void 0 ? void 0 : _b.flights
                    : availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.flights,
                path: "/".concat("".concat(language, "/flights-home")).concat(isPartnerRefererVal),
                isActive: function () { return tab === null || tab === void 0 ? void 0 : tab.includes('flights'); },
                Icon: Icons.FlightsIcon
            },
            {
                label: 'header.hotels',
                testId: 'hotels-home',
                value: 'hotels-home',
                isEnabled: partnerReferer
                    ? (_d = (_c = partnerConfig[partnerReferer]) === null || _c === void 0 ? void 0 : _c.availableProducts) === null || _d === void 0 ? void 0 : _d.hotels
                    : availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.hotels,
                path: "/".concat("".concat(language, "/hotels-home")).concat(isPartnerRefererVal),
                isActive: function () { return tab === null || tab === void 0 ? void 0 : tab.includes('hotels'); },
                Icon: Icons.HotelsIcon
            },
            {
                label: 'header.activities',
                testId: 'activities-home',
                value: 'activities-home',
                isEnabled: partnerReferer
                    ? (_f = (_e = partnerConfig[partnerReferer]) === null || _e === void 0 ? void 0 : _e.availableProducts) === null || _f === void 0 ? void 0 : _f.activities
                    : availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.activities,
                path: "/".concat("".concat(language, "/activities-home")).concat(isPartnerRefererVal),
                isActive: function () { return tab === null || tab === void 0 ? void 0 : tab.includes('activities'); },
                Icon: Icons.ActivitiesIcon
            }
        ];
    };
    var isActive = useCallback(function (item) {
        return item.isActive();
    }, []);
    var links = navLinks();
    return (React.createElement(Box, { sx: __assign(__assign({}, styles.mainHeaderContainer), { background: color(COLOR_VARIANTS.HEADER), color: color(COLOR_VARIANTS.HEADERTEXT), position: isFixed ? 'fixed' : 'sticky' }), 
        // @ts-ignore
        height: isFullHeader ? '130px' : '60px' },
        React.createElement(Box, { sx: isFullHeader
                ? {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: '12px'
                }
                : __assign(__assign({}, styles.headerContainer), { background: color(COLOR_VARIANTS.HEADER), position: isFixed ? 'fixed' : 'sticky' }) },
            React.createElement(Box, { sx: styles.headerContents },
                React.createElement(AlmosaferLogo, { language: language, partnerContent: partnerContent, query: query }),
                React.createElement(Box, { sx: __assign(__assign({}, styles.actionBarContainer), { height: isFullHeader && '66px' }) },
                    headerDisplayedItems.currency && (React.createElement(CurrencyDropdown, { currencyStore: currencyStore, language: language, onCurrencyChange: handleCurrencyChange, partnerReferer: partnerReferer, currencyList: currencyList })),
                    headerDisplayedItems.language && (React.createElement(Box, { sx: styles.changeLanguageButton, onClick: handleLanguageChange, testId: "change_language" }, language === 'en' ? 'العربية' : 'English')),
                    !isLoggedIn && (React.createElement(React.Fragment, null,
                        headerDisplayedItems.retrieveBooking && (React.createElement(Box, { sx: styles.retrieveBookingButton, onClick: handleRetrieveBooking },
                            React.createElement(React.Fragment, null, t('header.retrieve_my_booking')))),
                        headerDisplayedItems.phone && (React.createElement(Box, { sx: styles.whatsappNumber, onClick: function () { return (window.location.href = whatsappLink); } },
                            React.createElement(WhatsappIcon, null),
                            React.createElement("div", { style: {
                                    direction: 'ltr',
                                    order: dir === 'rtl' ? '-1' : '1'
                                } }, "+966554400000"))),
                        headerDisplayedItems.signIn && (React.createElement(Box, { sx: styles.signInButtonContainer },
                            React.createElement(ButtonBase, { "data-testid": "sign_in", "test-id": "sign_in", onClick: handleSignIn, sx: __assign(__assign({}, styles.signInButton), { borderColor: color(COLOR_VARIANTS.HEADERTEXT) }) },
                                React.createElement(React.Fragment, null, t('header.sign_In'))))))),
                    isLoggedIn && headerDisplayedItems.myAccount && (React.createElement(React.Fragment, null,
                        React.createElement(WalletAmount, { formatPrice: currencyStore.formatPrice, partnerContent: partnerContent, language: language }),
                        React.createElement(ButtonBase, { onClick: handleMyAccount, sx: styles.myAccountButton, "data-testid": "my_account_button", "test-id": "my_account_button" },
                            React.createElement(UserIcon, null),
                            React.createElement("div", { style: { marginInlineStart: '8px' } },
                                '  ',
                                " ",
                                language === 'ar' ? 'حسابي' : 'My account'))))))),
        isFullHeader && (React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(Box, { sx: styles.tabsContainer },
                React.createElement(Box, { sx: { width: '300px' } },
                    React.createElement("div", { style: { display: 'flex' } }, links.map(function (item) {
                        var Icon = item.Icon;
                        if (item.isEnabled) {
                            return (React.createElement(Box, { onClick: function () {
                                    // @ts-ignore
                                    window.location = item.path;
                                    setTab(item.value);
                                }, 
                                // @ts-ignore
                                // isActive={isActive(item)}
                                sx: {
                                    padding: '16px',
                                    cursor: 'pointer',
                                    borderBottom: "2px solid ".concat(isActive(item)
                                        ? color(COLOR_VARIANTS.HEADERTEXT)
                                        : color(COLOR_VARIANTS.HEADER)),
                                    display: 'flex',
                                    gap: '10px',
                                    '&:hover': {
                                        borderBottom: "2px solid ".concat(color(COLOR_VARIANTS.HEADERTEXT))
                                    }
                                } },
                                React.createElement(Icon
                                // @ts-ignore
                                , { 
                                    // @ts-ignore
                                    width: 16, 
                                    // @ts-ignore
                                    color: partnerReferer
                                        ? color(COLOR_VARIANTS.HEADERTEXT)
                                        : item.value !== 'activities-home' && 'white' }),
                                React.createElement("div", { style: {
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    } },
                                    React.createElement(React.Fragment, null, t(item.label)))));
                        }
                        return null;
                    }))))))));
};
export default HeaderV2;
//# sourceMappingURL=index.js.map